import {Component, Inject} from '@angular/core';
import {FormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {StrictDateAdapter, STRICT_DATE_FORMATS} from './strict-date-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';

/**NativeDateAdapter uses JavaScript's permissive date parsing,
 *so it can accept inputs that don't follow the intended YYYY-MM-DD format.
 * Added a custom adapter that validates the format and checks wheter the calendar date exists.
 **/

@Component({
    selector: 'app-generate-confirmation-dialog',
    templateUrl: './generate-confirmation-dialog.component.html',
    styleUrl: './generate-confirmation-dialog.component.scss',
    standalone: false,
    providers: [
      { provide: DateAdapter, useClass: StrictDateAdapter },
      { provide: MAT_DATE_FORMATS, useValue: STRICT_DATE_FORMATS }
    ]
})
export class GenerateConfirmationDialogComponent {
  formGroup: FormGroup;
  how_many: number;
  maxDate = new Date(9999, 11, 31);
  isPastDate: boolean = false;

  constructor(private readonly formBuilder: UntypedFormBuilder,
              private readonly dialogRef: MatDialogRef<GenerateConfirmationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.how_many = data.how_many;
    this.formGroup = this.formBuilder.group({
      maintEnd: [data.maintEnd, Validators.required]
    });

    // Initialize past date check
    this.updatePastDateStatus();
    
    // Subscribe to date changes
    this.formGroup.get('maintEnd')?.valueChanges.subscribe(() => {
      this.updatePastDateStatus();
    });
  }

  private updatePastDateStatus(): void {
    const dateValue = this.formGroup.get('maintEnd')?.value;
    this.isPastDate = this.isDateInPast(dateValue);
  }

  private isDateInPast(dateString: string | null | undefined): boolean {
    if (!dateString) return false;
    
    const selectedDate = new Date(dateString);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time for date-only comparison
    
    return selectedDate < today;
  }

  onSaveClick() {
    this.dialogRef.close(this.formGroup.value.maintEnd);
  }

  onCancelClick() {
    this.dialogRef.close();
  }
}
